import { Component, OnInit, Input } from '@angular/core';
import { MitterService } from '../../../services/mitter.service';

@Component({
  selector: 'mitter-receipt-icon',
  templateUrl: './receipt-icon.component.html',
  styleUrls: ['./receipt-icon.component.css']
})
export class ReceiptIconComponent implements OnInit {
  @Input() message: any;
  @Input() isUserSentMessage: boolean;

  mitter: any;

  showRead: boolean = false;
  showDelivered: boolean = false;
  showReceived: boolean = false;
  showSent: boolean = false;

  constructor(private mitterService: MitterService) {
    this.mitter = mitterService.getMitter();
  }

  ngOnInit() {
    if (this.isUserSentMessage) {
      this.showRead = this.message.timelineEvents
        .find(e => e.type === 'mitter.mtet.ReadTime' && e.subject.identifier !== this.mitter.getUserId());

      this.showDelivered = !this.showRead && this.message.timelineEvents
        .find(e => e.type === 'mitter.mtet.DeliveredTime' && e.subject.identifier !== this.mitter.getUserId());

      this.showReceived = !this.showDelivered && this.message.timelineEvents
        .find(e => e.type === 'mitter.mtet.ReceivedTime' && e.subject.identifier !== this.mitter.getUserId());

      if (!this.showRead && !this.showDelivered && !this.showReceived) {
        this.showSent = true;
      }
    }
  }
}
